/* ----------------------------------------------------------------
   HushTug - 在庫一覧テーブル（コレクションタブ＋キャッシュ方式）
------------------------------------------------------------------ */
(async () => {
  const API_ENDPOINT  = 'https://topics.hushtug.net/ourstore_inventory.php';
  const REFRESH_URL   = API_ENDPOINT + '?action=refresh';

  /* ---------- DOM ---------- */
  const $tabs    = document.getElementById('inv-tabs');
  const $search  = document.getElementById('inv-search');
  const $refresh = document.getElementById('inv-refresh');
  const $updated = document.getElementById('inv-updated');
  const $thead   = document.querySelector('#inv-table thead');
  const $tbody   = document.querySelector('#inv-table tbody');
  const $pinBox  = document.getElementById('pinned-box');
  const $pinHead = document.querySelector('#pinned-table thead');
  const $pinBody = document.querySelector('#pinned-table tbody');

  /* ---------- 状態 ---------- */
  let data        = null;
  let activeColId = null;
  const pinned    = new Map();

  /* ---------- データ取得 ---------- */
  async function fetchData(url = API_ENDPOINT) {
    const res = await fetch(url, { cache: 'no-store' });
    data = await res.json();

    // デフォルトコレクションを初回だけセット
    if (!activeColId) {
      const def = data.collections.find(c => c.default) ?? data.collections[0];
      activeColId = def?.id ?? null;
    }

    buildTabs();

    if ($updated && data.generated_at) {
      const d = new Date(data.generated_at);
      $updated.textContent = '最終更新: ' + d.toLocaleString('ja-JP');
    }
  }

  /* ---------- タブ描画 ---------- */
  function buildTabs() {
    $tabs.innerHTML = data.collections.map(col => `
      <button
        class="inv-tab${col.id === activeColId ? ' active' : ''}"
        data-col="${col.id}"
        style="padding:6px 14px;border:1px solid #ccc;cursor:pointer;
               background:${col.id === activeColId ? '#333' : '#fff'};
               color:${col.id === activeColId ? '#fff' : '#333'};
               border-radius:4px;font-size:0.9rem;"
      >${col.name}</button>`
    ).join('');
  }

  $tabs.addEventListener('click', e => {
    const btn = e.target.closest('.inv-tab');
    if (!btn) return;
    activeColId = btn.dataset.col;
    // タブの見た目を更新
    $tabs.querySelectorAll('.inv-tab').forEach(b => {
      const active = b === btn;
      b.classList.toggle('active', active);
      b.style.background = active ? '#333' : '#fff';
      b.style.color      = active ? '#fff' : '#333';
    });
    filter();
  });

  /* ---------- フィルタ ---------- */
  function getView() {
    const kw = $search.value.trim().toLowerCase();
    return (data?.products ?? []).filter(p => {
      if (!p.collections.includes(activeColId)) return false;
      if (!kw) return true;
      return p.title.toLowerCase().includes(kw) ||
             (p.sku && p.sku.toLowerCase().includes(kw));
    });
  }

  function filter() {
    if (!data) return;
    build(getView());
  }

  /* ---------- テーブル描画 ---------- */
  /* 全ロケーション在庫0以下 かつ 予約なし → 販売停止 */
  function etaLabel(d, locs) {
    if (!d.eta && locs.every(l => (d.inventory[l] ?? 0) <= 0)) {
      return '<span style="color:#FF5049;font-weight:900">販売停止</span>';
    }
    return esc(d.eta || '');
  }

  function build(view) {
    const locs = data.locations;

    /* メインテーブル */
    $thead.innerHTML = `
      <tr>
        <th style="width:28px"></th>
        <th>画像</th>
        <th>SKU</th>
        <th style="min-width:200px">商品名</th>
        ${locs.map(l => `<th>${l}</th>`).join('')}
        <th>お届け予定</th>
      </tr>`;

    $tbody.innerHTML = view.map(d => `
      <tr data-sku="${esc(d.sku)}">
        <td class="pin-cell">
          <button class="pin-btn" title="検討リストに追加 / 解除">
            ${pinned.has(d.sku) ? '📌' : '📍'}
          </button>
        </td>
        <td><img src="${esc(d.img)}" alt="${esc(d.alt)}" style="width:50px"></td>
        <td>${esc(d.sku)}</td>
        <td>${esc(d.title)}</td>
        ${locs.map(l => `<td>${d.inventory[l] ?? 0}</td>`).join('')}
        <td>${etaLabel(d, locs)}</td>
      </tr>`).join('');

    /* ピン留めテーブル */
    buildPinned(locs);
  }

  function buildPinned(locs) {
    if (!pinned.size) {
      $pinBox.style.display = 'none';
      $pinHead.innerHTML = $pinBody.innerHTML = '';
      return;
    }
    const pins = [...pinned.values()];
    $pinHead.innerHTML = `
      <tr>
        <th>画像</th>
        <th>SKU</th>
        <th style="min-width:160px">商品名</th>
        ${locs.map(l => `<th>${l}</th>`).join('')}
        <th>お届け</th>
        <th style="width:28px"></th>
      </tr>`;
    $pinBody.innerHTML = pins.map(d => `
      <tr data-sku="${esc(d.sku)}">
        <td><img src="${esc(d.img)}" alt="${esc(d.alt)}" style="width:50px"></td>
        <td>${esc(d.sku)}</td>
        <td>${esc(d.title)}</td>
        ${locs.map(l => `<td>${d.inventory[l] ?? 0}</td>`).join('')}
        <td>${etaLabel(d, locs)}</td>
        <td><button class="pin-btn" title="リストから外す">❌</button></td>
      </tr>`).join('');
    $pinBox.style.display = '';
  }

  /* ---------- ピン / 解除 ---------- */
  document.addEventListener('click', e => {
    if (!e.target.classList.contains('pin-btn')) return;
    const sku = e.target.closest('tr')?.dataset.sku;
    if (!sku || !data) return;
    if (pinned.has(sku)) {
      pinned.delete(sku);
    } else {
      const row = data.products.find(p => p.sku === sku);
      if (row) pinned.set(sku, row);
    }
    filter();
  });

  /* ---------- 検索・更新 ---------- */
  $search.addEventListener('input', filter);

  $refresh.addEventListener('click', async () => {
    $refresh.disabled    = true;
    $refresh.textContent = '更新中…';
    try {
      await fetchData(REFRESH_URL);
      filter();
    } catch (e) {
      console.error(e);
    }
    $refresh.disabled    = false;
    $refresh.textContent = '更新';
  });

  /* ---------- XSSエスケープ ---------- */
  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ---------- 初期化 ---------- */
  try {
    await fetchData();
    filter();
  } catch (e) {
    console.error('在庫データの取得に失敗しました', e);
    $tbody.innerHTML = '<tr><td colspan="99" style="text-align:center;padding:20px;">データ取得に失敗しました。更新ボタンを押してください。</td></tr>';
  }
})();
